"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeItemPathKey = exports.shallowCloneItemWithPath = exports.LogCountLimiter = exports.Utils = void 0;
var logging_1 = require("@augloop/logging/dist/src/client/logging");
var schemas_1 = require("@augloop/schemas/dist/src/client/schemas");
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.createHealthCheckRequest = function (clientMetadata) {
        return {
            payload: {},
            payloadSchema: { category: schemas_1.TypeCategory.Schema, schema: { name: 'HealthCheckRequest' } },
            requestedSchema: { category: schemas_1.TypeCategory.Schema, schema: { name: 'HealthCheckResponse' } },
            clientMetadata: clientMetadata
        };
    };
    Utils.isFeatureEnabled = function (hostCallbacks, featureName, defaultValue, scope) {
        if (defaultValue === void 0) { defaultValue = false; }
        if (scope === void 0) { scope = 'None'; }
        return hostCallbacks && hostCallbacks.isFeatureEnabled
            ? hostCallbacks.isFeatureEnabled('Microsoft.Office.AugLoop.' + featureName, scope)
                .catch(function () { return Promise.resolve(defaultValue); })
            : Promise.resolve(defaultValue);
    };
    Utils.convertWebSocketUrlToHttp = function (webSocketUrl) {
        return this.convertUrl(webSocketUrl, false);
    };
    Utils.convertServiceUrlToWebSocket = function (serviceUrl) {
        return this.convertUrl(serviceUrl, true);
    };
    Utils.convertUrl = function (url, convertToWs /** true for ws(s), false for http(s) */) {
        if (!url) {
            return url;
        }
        var urlOnColon = url.split(':');
        var serviceProtocol = urlOnColon[0].toLowerCase();
        if (serviceProtocol.indexOf(convertToWs ? 'http' : 'ws') == 0) {
            serviceProtocol = convertToWs ? serviceProtocol.replace('http', 'ws') : serviceProtocol.replace('ws', 'http');
            urlOnColon[0] = serviceProtocol;
            return urlOnColon.join(':');
        }
        return url;
    };
    /**
     * Gets current time, expressed in milliseconds since 00:00 UTC 1 Jan 1970.
     * Note that older versions of some browsers can produce NaN as result.
     */
    Utils.getCurrentTimeMs = function () {
        return Date.now ? Date.now() : new Date().getTime();
    };
    return Utils;
}());
exports.Utils = Utils;
var LogCountLimiter = /** @class */ (function () {
    function LogCountLimiter(id) {
        this.maxNumberOfLogs = 40;
        this.numberOfLogs = 0;
        this.id = id;
    }
    LogCountLimiter.prototype.log = function (logCode) {
        if (this.numberOfLogs < this.maxNumberOfLogs) {
            this.numberOfLogs++;
            logCode();
            if (this.numberOfLogs === this.maxNumberOfLogs) {
                var op = new logging_1.Operation({
                    operationName: 'OnLastLog',
                    success: true,
                    resourceId: this.id,
                    resultDescription: "Limit for number of logs for id: " + this.id + " reached - all next logs will be dropped",
                });
                logging_1.Log.warn(0x2224d0db /* tag_8jnd1 */, logging_1.LogCategory.CoreDefault, op);
            }
        }
    };
    return LogCountLimiter;
}());
exports.LogCountLimiter = LogCountLimiter;
var itemPathSeparatorChar = '\\';
/**
 * Makes an ItemWithPath from an Item by making a shallow clone and adding the parent path.
 * Note: Copy-pasted from @augloop/session-cache module as it can't be consumed in the browser yet.
 * TODO #5326116: Remove this function once session cache is made compatible with local workflows.
 */
var shallowCloneItemWithPath = function (parentPath, item) {
    return {
        id: item.id,
        source: item.source,
        revId: item.revId,
        body: item.body,
        parentPath: parentPath
    };
};
exports.shallowCloneItemWithPath = shallowCloneItemWithPath;
/**
 * Turns an ItemPath into a string value that can be used as a key (or for logging)
 * Note: Copy-pasted from @augloop/session-cache module as it can't be consumed in the browser yet.
 * TODO #5326116: Remove this function once session cache is made compatible with local workflows.
 */
var makeItemPathKey = function (path) {
    if (Array.isArray(path)) {
        if (path.length === 5) {
            return "" + path[0] + itemPathSeparatorChar + path[1] + itemPathSeparatorChar + path[2] + itemPathSeparatorChar + path[3] + itemPathSeparatorChar + path[4];
        }
        if (path.length === 4) {
            return "" + path[0] + itemPathSeparatorChar + path[1] + itemPathSeparatorChar + path[2] + itemPathSeparatorChar + path[3];
        }
        if (path.length === 3) {
            return "" + path[0] + itemPathSeparatorChar + path[1] + itemPathSeparatorChar + path[2];
        }
        if (path.length === 2) {
            return "" + path[0] + itemPathSeparatorChar + path[1];
        }
        if (path.length === 1) {
            return path[0];
        }
        return path.join(itemPathSeparatorChar);
    }
    return '(malformed path)';
};
exports.makeItemPathKey = makeItemPathKey;
//# sourceMappingURL=utils.js.map